// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-title {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  padding: 0px 24px;
}
.comp-title > .title {
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  color: var(--color-contrast-dark-gray);
}
.comp-title > .p1-paragraph {
  max-width: 1200px;
  text-align: center;
}
.comp-title > .p1-paragraph span {
  color: var(--color-primary-red);
}

@media (max-width: 768px) {
  .comp-title > .title {
    font-size: 28px;
  }
  .comp-title > .p1-paragraph {
    font-size: var(--font-size-p3-paragraph);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/title.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,wCAAwC;EAC1C;AACF","sourcesContent":[".comp-title {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 32px;\n  padding: 0px 24px;\n}\n.comp-title > .title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  width: 100%;\n  color: var(--color-contrast-dark-gray);\n}\n.comp-title > .p1-paragraph {\n  max-width: 1200px;\n  text-align: center;\n}\n.comp-title > .p1-paragraph span {\n  color: var(--color-primary-red);\n}\n\n@media (max-width: 768px) {\n  .comp-title > .title {\n    font-size: 28px;\n  }\n  .comp-title > .p1-paragraph {\n    font-size: var(--font-size-p3-paragraph);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
